<!-- eslint-disable vue/no-v-html -->
<template>
	<b-form
		class="mx-3">
		<!-- Airline & Flight Number -->
		<b-row>
			<b-col>
				<b-form-group>
					<label>
						{{ translate('airline') }}
						<span class="text-danger">*</span>
					</label>
					<b-form-input
						id="airline"
						v-model="value.airline"
						name="airline"
						:class="hasError('airline') ? 'is-invalid' : ''"
						:placeholder="translate('airline')"
						required />
					<p
						class="text-small text-muted mb-0 pb-0"
						v-html="translate('airline_example')" />
					<template v-if="hasError('airline')">
						<span
							v-for="error in errors['airline']"
							:key="error"
							class="invalid-feedback animated fadeIn"
							v-text="error" />
					</template>
				</b-form-group>
			</b-col>
			<b-col>
				<b-form-group>
					<label>
						{{ translate('flight_number') }}
						<span class="text-danger">*</span>
					</label>
					<b-form-input
						id="flight_number"
						v-model="value.flight_number"
						name="flight_number"
						:class="hasError('flight_number') ? 'is-invalid' : ''"
						:placeholder="translate('flight_number')"
						required />
					<p
						class="text-small text-muted mb-0 pb-0"
						v-html="translate('flight_number_example')" />
					<template v-if="hasError('flight_number')">
						<span
							v-for="error in errors['flight_number']"
							:key="error"
							class="invalid-feedback animated fadeIn"
							v-text="error" />
					</template>
				</b-form-group>
			</b-col>
		</b-row>
		<!-- Departure Info -->
		<b-row>
			<b-col>
				<b-form-group>
					<label>
						{{ translate('departure_city') }}
						<span class="text-danger">*</span>
					</label>
					<b-form-input
						id="departure_city"
						v-model="value.departure_city"
						name="departure_city"
						:class="hasError('departure_city') ? 'is-invalid' : ''"
						type="text"
						maxlenght="8"
						:placeholder="translate('departure_city')"
						required />
					<p
						class="text-small text-muted mb-0 pb-0"
						v-html="translate('departure_city_example')" />
					<template v-if="hasError('departure_city')">
						<span
							v-for="error in errors['departure_city']"
							:key="error"
							class="invalid-feedback animated fadeIn"
							v-text="error" />
					</template>
				</b-form-group>
			</b-col>
			<b-col>
				<b-form-group>
					<label>
						{{ translate('departure_datetime') }}
						<span class="text-danger">*</span>
					</label>
					<b-row>
						<b-col
							cols="6"
							class="pr-2">
							<b-form-datepicker v-model="departure.date" />
						</b-col>
						<b-col
							cols="6"
							class="pl-2">
							<b-form-timepicker v-model="departure.time" />
						</b-col>
					</b-row>
					<p class="text-small text-muted mb-0 pb-0">
						{{ translate('departure_datetime_example') }}
					</p>
					<template v-if="hasError('departure_date')">
						<span
							v-for="error in errors['departure_date']"
							:key="error"
							class="custom-invalid-feedback animated fadeIn"
							v-text="error" />
					</template>
				</b-form-group>
			</b-col>
		</b-row>
		<!-- Arrival Info -->
		<b-row>
			<b-col>
				<b-form-group>
					<label>
						{{ translate('arrival_city') }}
						<span class="text-danger">*</span>
					</label>
					<b-form-input
						id="arrival_city"
						v-model="value.arrival_city"
						name="arrival_city"
						:class="hasError('arrival_city') ? 'is-invalid' : ''"
						type="text"
						:placeholder="translate('arrival_city')"
						required />
					<p
						class="text-small text-muted mb-0 pb-0"
						v-html="translate('arrival_city_example')" />
					<template v-if="hasError('arrival_city')">
						<span
							v-for="error in errors['arrival_city']"
							:key="error"
							class="invalid-feedback animated fadeIn"
							v-text="error" />
					</template>
				</b-form-group>
			</b-col>
			<b-col>
				<b-form-group>
					<label>
						{{ translate('arrival_datetime') }}
						<span class="text-danger">*</span>
					</label>
					<b-row>
						<b-col
							cols="6"
							class="pr-2">
							<b-form-datepicker v-model="arrival.date" />
						</b-col>
						<b-col
							cols="6"
							class="pl-2">
							<b-form-timepicker v-model="arrival.time" />
						</b-col>
					</b-row>
					<p class="text-small text-muted mb-0 pb-0">
						{{ translate('arrival_datetime_example') }}
					</p>
					<template v-if="hasError('arrival_date')">
						<span
							v-for="error in errors['arrival_date']"
							:key="error"
							class="custom-invalid-feedback animated fadeIn"
							v-text="error" />
					</template>
				</b-form-group>
			</b-col>
		</b-row>
		<hr>
		<h4>
			{{ translate('event_departure') }}
		</h4>
		<!-- Event departure info -->
		<b-row>
			<b-col cols="12">
				<p>
					{{ translate('event_departure_description') }}
				</p>
			</b-col>
			<b-col>
				<b-form-group>
					<label>
						{{ translate('event_departure_time') }}
						<span class="text-danger">*</span>
					</label>
					<b-row>
						<b-col
							cols="6"
							class="pr-2">
							<b-form-datepicker v-model="eventDeparture.date" />
						</b-col>
						<b-col
							cols="6"
							class="pl-2">
							<b-form-timepicker v-model="eventDeparture.time" />
						</b-col>
					</b-row>
					<template v-if="hasError('event_departure_date')">
						<span
							v-for="error in errors['event_departure_date']"
							:key="error"
							class="custom-invalid-feedback animated fadeIn"
							v-text="error" />
					</template>
				</b-form-group>
			</b-col>
		</b-row>
		<!-- Checkbox -->
		<hr>
		<b-row>
			<b-col cols="12">
				<div class="form-check">
					<input
						id="confirmationCheckbox"
						:checked="disclaimer"
						class="form-check-input"
						type="checkbox"
						@change="$emit('disclaimer-change', $event.target.checked)">
					<label
						class="form-check-label"
						for="confirmationCheckbox"
						v-html="translate('checkbox_confirmation')" />
				</div>
			</b-col>
		</b-row>
	</b-form>
</template>
<script>
import {
	Popups, PersonalInformation, Onboarding, Events,
} from '@/translations';

export default {
	messages: [Popups, PersonalInformation, Onboarding, Events],
	props: {
		value: {
			type: Object,
			default: () => ({}),
		},
		loading: {
			type: Boolean,
			default: false,
		},
		stepInfo: {
			type: Object,
			default: () => ({}),
		},
		errors: {
			type: Object,
			default: () => ({}),
		},
		disclaimer: Boolean,
	},
	data() {
		return {
			alert: new this.$Alert(),
			departure: {
				date: null,
				time: null,
			},
			arrival: {
				date: null,
				time: null,
			},
			eventDeparture: {
				date: null,
				time: null,
			},
		};
	},
	watch: {
		departure: {
			handler() {
				this.value.departure_date = `${this.departure.date} ${this.departure.time}`;
			},
			deep: true,
		},
		arrival: {
			handler() {
				this.value.arrival_date = `${this.arrival.date} ${this.arrival.time}`;
			},
			deep: true,
		},
		eventDeparture: {
			handler() {
				this.value.event_departure_date = `${this.eventDeparture.date} ${this.eventDeparture.time}`;
			},
			deep: true,
		},
	},
	methods: {
		hasError(field) {
			return typeof this.errors[field] !== 'undefined';
		},
		clearError(field) {
			if (field) {
				delete this.errors[field];
				this.errors = { ...this.errors };
			}
		},
	},
};
</script>
